export default function convertBDTimeToLocal(
  day,
  time,
  timezone = "Asia/Dhaka"
) {
  // Map day names to numbers (0 = Sunday, ..., 6 = Saturday)
  const daysOfWeek = {
    Sunday: 0,
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
  };

  // Parse time (e.g., "00:30" as 24-hour format)
  let [hours, minutes] = time.split(":").map(Number);
  if (hours === 0) hours = 0; // Ensure "00:30" is treated as 12:30 AM

  // Get the current date and find the next occurrence of the specified day
  const now = new Date();
  const currentDay = now.getDay();
  const targetDay = daysOfWeek[day];
  const daysUntilTarget = (targetDay - currentDay + 7) % 7 || 7; // Next occurrence

  // Create a Date object for the schedule in UTC
  const utcDate = new Date(
    Date.UTC(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + daysUntilTarget,
      hours,
      minutes
    )
  );

  // Adjust for Bangladesh time (UTC+6)
  const bdtOffset = 6 * 60; // BDT offset in minutes
  utcDate.setMinutes(utcDate.getMinutes() - bdtOffset); // Convert BDT to UTC

  // Convert to local timezone
  const formatter = new Intl.DateTimeFormat("en-US", {
    weekday: "long",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone, // User's local timezone
  });

  return formatter.format(utcDate);
}
